var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-page',{attrs:{"title":"多多商城"}},[_c('GroupBuyingView',{attrs:{"id":_vm.query.id,"show-pending-payment-order":true}},[_c('x-open-app')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }